import React, { useContext } from 'react';
import { Row, Col, Checkbox, CheckboxGroup, SelectAllCheckbox, Box } from '@digitools/honest-react';
import { useFieldState } from 'informed';
import { handleProductAllSelection, checkBoxSelection } from '../api';
import { AuthenticationContext } from 'src/providers/AuthenticationProvider';
const Crs = (props) => {
    const authContext = useContext(AuthenticationContext);
    const hasCrsAccess = props.permissions.permission.crsER;
    const crsChange = (event) => {
        props.userInfo.customerReportingSolution = event;
    };
    // Disabled-gating reads the live Create My Report field value from informed. Coalesce to the user
    // model for the first render, before the field has registered and reported its initialValue.
    const { value: createMyReportValue } = useFieldState('createMyReport');
    const crsEnabled = createMyReportValue ?? props.userInfo.customerReportingSolution;
    const crsUpdate = (event) => {
        crsChange(event.currentTarget.checked);
    };
    return (<>
      {hasCrsAccess ? (<div style={{ marginTop: '1.5rem' }}>
          <Box type='header' color={'grayLighter'}>
            <Checkbox field='createMyReport' label={'Create My Report'} initialValue={props.userInfo.customerReportingSolution} onChange={crsUpdate}/>
          </Box>
          <Box>
            {props.sensitiveData.length > 0 ? (<CheckboxGroup field={'sensitiveDataGroup'} label={'Sensitive Data'} validateOnChange={true}>
                <Row>
                  <Col lg={4}>
                    <SelectAllCheckbox title={'Sensitive Data'} field={'sensitiveAll'} disabled={!crsEnabled} onChange={(event) => handleProductAllSelection({ code: 'sensitiveAll', label: 'All', checked: event.currentTarget.checked }, props.sensitiveData, 'crsSensitive', props.userInfo, props.customerConfig)}/>
                  </Col>
                </Row>
                <Row style={{ marginTop: '-0.05rem' }}>
                  {checkBoxSelection(props.sensitiveData, 'crsSensitive', crsEnabled, props.userInfo, props.customerConfig)}
                </Row>
              </CheckboxGroup>) : (<></>)}
          </Box>
        </div>) : (<></>)}
    </>);
};
export default Crs;
